<template>
  <div
    v-if="formVisible"
    class="flex flex-col md:flex-row items-start md:items-center gap-4"
  >
    <input
      v-model="pin"
      type="password"
      placeholder="Kods"
      class="w-[100px] px-4 pt-3 pb-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 uppercase martel-sans-regular leading-normal text-sm"
    />

    <input
      v-model="email"
      type="email"
      placeholder="Tavs e-pasts"
      class="flex-1 px-4 pt-3 pb-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 uppercase martel-sans-regular leading-normal text-sm block w-full"
    />

    <button
      @click="sendImageToEmail"
      class="bg-red-700 text-white martel-sans-regular rounded-lg shadow-md hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-red-300 focus:ring-offset-2 uppercase px-6 text-sm pt-3 pb-2"
    >
      Saņemt karti
    </button>
  </div>
  <div>
    <div v-if="error" class="text-red-600 font-medium mt-4">{{ error }}</div>
    <div v-if="successMessage" class="text-green-600 font-medium mt-4">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      pin: "",
      email: "",
      error: "",
      successMessage: "",
      formVisible: true, // Controls form visibility
    };
  },
  methods: {
    async sendImageToEmail() {
      try {
        await axios.post("/api/send-image", {
          pin: this.pin,
          email: this.email,
        });

        this.successMessage = "Darbinieka labumu karte nosūtīta uz e-pastu!";
        this.error = "";
        this.formVisible = false; // Hide the form
      } catch (error) {
        console.error("Error in sendImageToEmail:", error);
        this.error =
          "Kaut kas nogāja greizi. Lūdzu, pārbaudiet ievadīto informāciju un mēģiniet vēlreiz!";
        this.successMessage = "";
      }
    },
  },
};
</script>
